import { EventEmitter } from 'events';

export class DocItem extends EventEmitter {
  constructor(rawData, options) {
    super();
    this.__raw = rawData;
    this.__loaded = false;

    const self = this;
    const { $scopeElement } = options;
    $scopeElement.on('createdChildren', evt => {
      const $target = $(evt.target);
      self.__setElements($target);
    });
  }

  __setElements($scope) {
    this.__loaded = true;
    this.$anchor = $scope
      .find(`li.md > a.link-item[data-url="${this.url}"]`);
    const $element = this.$anchor.parent();
    this.$element = $element;
    this.__loaded = true;
    this.emit({
      type: 'ready',
      target: $element[0],
    });
  }

  getRawData(path) {
    return _.get(this.__raw, path);
  }

  get loaded() {
    return this.__loaded;
  }

  get id() {
    return this.getRawData('cid');
  }

  get url() {
    return this.getRawData('url');
  }

  get name() {
    return this.getRawData('name');
  }

  get label() {
    return this.getRawData('label');
  }

  get data() {
    return this.getRawData('data');
  }
}
